module.exports = __webpack_public_path__ + "static/media/About_Us_Breadcrumb.39407896.svg";